<template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="calc(80% - 0px)" center
        :close-on-click-modal="false" :before-close="handleClose">
        <div>
            <el-table size="small" height="calc(90vh - 300px)" border row-key="id" :data="tableData"
                v-loading="loadingPage" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
                <el-table-column fixed min-width="60" prop="dev_uuid" label="UUID"></el-table-column>
                <el-table-column min-width="200" prop="file_path" label="文件路径"></el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <span style="color: blue;" @click="handleShowLog(scope.row)">实时日志</span>
                        <span style="color: blue; margin-left: 15px;" @click="handleDownloadLog(scope.row)">下载日志</span>
                    </template>
                </el-table-column>
            </el-table>
            <LogView ref="logViewFlag" @refreshData="getData"></LogView>
        </div>
    </el-dialog>
</template>
<script>
import LogView from '../RemoteLogDevices/LogView.vue'

export default {
    components: {
        LogView
    },
    name: 'logViewFlag',
    data() {
        return {
            loadingPage: false,
            dialogVisible: false,
            dialogTitle: '',
            formInline: {
                id: '',
                dev_uuid: '',
                file_path: '',

                page: 1,
                limit: 999
            },
            tableData: [],
            isUploading: false,
        }

    },
    methods: {
        handleClose() {
            this.dialogVisible = false
            this.loadingPage = false
        },
        fileListFlagFn(data, flag) {
            this.dialogVisible = true
            this.dialogTitle = flag

            this.formInline.dev_uuid = data.uuid

            this.getData()
        },
        handleShowLog(row){
            this.$refs.logViewFlag.logViewFlagFn(row, '实时日志查看')
        },
        async handleDownloadLog(row){
            // 原：隐藏 iframe 直接打开 8484 明文静态地址（无鉴权）。现改走鉴权接口：
            // JWT 登录态 + 远程日志查看权限，nginx 侧 8484 已停止静态下发。
            const baseName = (row.file_path || '').split('/').pop() || 'messages.log'
            const fileName = row.dev_uuid ? row.dev_uuid + '_' + baseName : baseName
            const url = this.$http.host + 'remote-log-file-list/download/?file_path=' + encodeURIComponent(row.file_path)
            try {
                const response = await fetch(url, {
                    headers: { Authorization: 'JWT ' + localStorage.getItem('token') }
                })
                if (!response.ok) {
                    let msg = '日志下载失败，请确认登录状态和远程日志查看权限'
                    try {
                        const data = await response.json()
                        msg = data.msg || data.detail || msg
                    } catch (e) {
                        // 非 JSON 错误响应，使用默认提示
                    }
                    throw new Error(msg)
                }
                const blob = await response.blob()
                const eLink = document.createElement('a')
                eLink.download = fileName
                eLink.style.display = 'none'
                eLink.href = URL.createObjectURL(blob)
                document.body.appendChild(eLink)
                eLink.click()
                URL.revokeObjectURL(eLink.href)
                document.body.removeChild(eLink)
            } catch (error) {
                this.$message.warning(error.message || '日志下载失败，请稍后重试')
            }
        },
        async getData(){
            let param = {
                uuid: this.formInline.dev_uuid
            }
            this.loadingPage=true
            this.$http['get']('remote-log-file-list/', param, res=>{
                this.loadingPage=false
                if(res.code == 200 && res.status == 'success'){
                    this.tableData = res.data.results
                }else{
                    this.$message.warning(res.data.msg)
                }
            })
        }
    },
    created() {

    }
}
</script>
<style>
span:hover {
    cursor: pointer;
}
</style>